<template>
    <b-modal
            no-enforce-focus
            ref="contentNewListModal"
            :id="id"
            no-close-on-backdrop
            size="xl"
            :title="formData.label ? formData.label : 'New Page'">
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.contentNewListModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="busy" variant="primary" v-on:click.native="onSubmit()">
                SAVE
            </pb-btn>
        </template>
        <b-container class="text-left">
            <b-row>
                <b-col>
                    <b-form>
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col md="4">
                                <label for="name">Name</label>
                                <b-form-input
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder="Name"
                                        v-model.trim="formData.name"
                                        v-validate="'required'"
                                        :state="validateState('name')"
                                ></b-form-input>
                            </b-col>
                            <b-col md="4">
                                <label for="label">Label</label>
                                <b-form-input
                                        id="label"
                                        name="label"
                                        type="text"
                                        placeholder="Label"
                                        v-model.trim="formData.label"
                                        v-validate="'required'"
                                        :state="validateState('label')"
                                ></b-form-input>
                            </b-col>
                            <b-col md="4">
                                <label for="templateSelect">Template</label>
                                <b-form-select :disabled="!!(formData.id)" id="templateSelect" v-model="template"
                                               :options="templateOptions"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>


    import ContentAPI from "@shared/_api/cms/content";
    import FormGenerator from "../form/FormGenerator";
    import TemplateApi from "../../../../../shared/_api/cms/template";

    function initialData() {
        return {
            busy: false,
            submitError: null,
            selectedTemplate: null,
            schema: {},
            formData: {
                id: null,
                label: null,
                name: null,

                contentList: []
            }
        }
    }

    export default {
        name: 'content-list-modal',
        props: {
            id: String
        },
        data() {
            return {
                ...initialData(),
                template: null,
                templateList: []
            };
        },
        components: {
            "form-generator": FormGenerator
        },
        mounted() {
            TemplateApi.get().then((templateList) => {
                this.templateList = templateList;
            }).catch(error => {
                this.apiError = error;
            }).finally(() => {
                this.busy = false;
            })
        },
        methods: {
            manageEntity(entity, template) {
                this.$validator.reset().finally(() => {
                    Object.assign(this.$data, initialData());
                    Object.assign(this.$data.formData, entity);
                });
                this.template = template;
            },
            onSubmit() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.busy = true;
                        let apiFunction = this.formData.id ? ContentAPI.updateList(this.formData) : ContentAPI.addList(this.formData, this.template);
                        apiFunction.then(() => {
                            this.$nextTick(() => {
                                this.$emit('saved');
                                this.$refs.contentNewListModal.hide();
                            })
                        }).catch(() => {
                            this.submitError = "An error occured.";
                        }).finally(() => {
                            this.busy = false;
                        });
                    }
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            }
        },
        computed: {
            templateOptions() {
                return this.templateList.map(template => {
                    return {
                        value: template.id,
                        text: template.label
                    }
                })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
